import React from "react";
import useFetch from "../hooks/useFetch";
import ProductCard from "../pages/all_products/ProductCard";
import { SkeletonCard } from "../pages/all_products/AllProducts";

const ProdListing = ({ api_url }) => {
  const { data: proData, loading } = useFetch(api_url);
  const data = proData?.results || [];
  return (
    <section>
      <div className="flex flex-wrap gap-4 md:justify-start justify-center">
        {loading
          ? Array.from({ length: 8 }).map((_, index) => (
              <div key={index}>
                <SkeletonCard />
              </div>
            ))
          : data?.map((d, i) => (
              <div key={d.id} className="xl:w-[320px] md:w-[200px] w-[140px]">
                <ProductCard product={d} />
              </div>
            ))}
      </div>
    </section>
  );
};

export default ProdListing;
